import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../utils/translations';
import {ALERT_ERROR__32} from '@homeaway/svg-defs/lib/defs/ALERT_ERROR__32';
import {SVGIcon} from '@homeaway/react-svg';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import './ComponentError.less';

export class ComponentError extends React.Component {
    static propTypes = {
        errorText: PropTypes.string,
        loading: PropTypes.bool,
        title: PropTypes.string,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const errorText =
            this.props.errorText ||
            translate(
                this.props.translations,
                'trav-dash/trav-home',
                'messages',
                'th.inbox.error.message'
            );

        if (this.props.loading) {
            return (
                <div className="ComponentError position-relative">
                    <LoadingOverlay />
                </div>
            );
        }

        return (
            <div className="ComponentError">
                {this.props.title && <h3>{this.props.title}</h3>}
                <div className="text-center">
                    <span className="text-danger hidden-xs">
                        <SVGIcon markup={ALERT_ERROR__32} useFill />
                    </span>
                    <p>{errorText}</p>
                </div>
            </div>
        );
    }
}
